import React, { memo, SVGProps } from 'react'

export const ChevronDown = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 15.024C12.1843 15.024 12.3687 14.9539 12.5088 14.8128L17.1168 10.2048C17.3981 9.92352 17.3981 9.46752 17.1168 9.18624C16.8355 8.90496 16.3795 8.90496 16.0983 9.18624L11.9991 13.2854L7.89987 9.18624C7.61859 8.90496 7.16259 8.90496 6.88131 9.18624C6.60003 9.46752 6.60003 9.92352 6.88131 10.2048L11.4893 14.8128C11.6295 14.953 11.8138 15.024 11.9981 15.024H12Z"
      fill="currentColor"
    />
  </svg>
))
